export default "/Frontend/dist/event-background.4008ffc059a59791d78f0ddae5230643.svg";